import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import idpService from '../services/idp';
import '../styles/login.css';

// Empty string → relative URLs (/api/…) proxied by nginx.
const API_BASE = (process.env.REACT_APP_API_URL ?? window.__ENV__?.API_URL ?? '').replace(/\/$/, '');

function Login() {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();

  // Handle IdP callback with auth token
  useEffect(() => {
    const code = searchParams.get('code');
    const token = searchParams.get('idp_token') || searchParams.get('token');

    if (code) {
      // Código de un solo uso: el token no viaja en la URL (ver
      // services/idp.js). El canje lo hace el backend contra el IdP.
      idpService
        .exchangeCode(code)
        .then((nuevoToken) => {
          localStorage.setItem('token', nuevoToken);
          window.location.replace('/');
        })
        .catch((err) => {
          console.error('[SSO] No se pudo canjear el código:', err);
        });
      return;
    }

    if (token) {
      console.warn('[SSO] Token recibido en la URL: camino heredado, en desuso');
      localStorage.setItem('token', token);
      window.location.href = '/';
    }
  }, [searchParams]);

  const handleSubmit = (e) => {
    e.preventDefault();
    handleIdPLogin();
  };

  const handleIdPLogin = () => {
    // Redirect to IdP login page
    const returnUrl = encodeURIComponent(window.location.origin + '/');
    window.location.href = `${API_BASE}/api/auth/login?return_to=${returnUrl}`;
  };

  const handleDemoLogin = () => {
    localStorage.setItem('token', 'demo-token');
    localStorage.setItem('user', JSON.stringify({ username: 'demo', role: 'admin', company_id: 1 }));
    // Force page reload to trigger App.jsx re-authentication
    window.location.href = '/';
  };

  return (
    <div className="login-page">

      {/* — animated background — */}
      <div className="l-bg">
        <div className="l-orb" />
        <div className="l-orb" />
        <div className="l-orb" />
      </div>

      {/* — left branding panel — */}
      <div className="l-brand">
        <div className="l-brand-logo">
          <div className="l-brand-icon">🗄️</div>
          <span className="l-brand-name">Adder <em>CMDB</em></span>
        </div>

        <h1 className="l-headline">
          Configuration<br />
          <span>Management</span><br />
          Database
        </h1>

        <p className="l-subtext">
          Gestiona activos, relaciones y configuraciones de tu infraestructura
          con visibilidad completa y control total.
        </p>

        <div className="l-pills">
          <span className="l-pill"><span className="l-pill-dot" />Inventario de Activos</span>
          <span className="l-pill"><span className="l-pill-dot" />Relaciones CI</span>
          <span className="l-pill"><span className="l-pill-dot" />Multi-Empresa</span>
          <span className="l-pill"><span className="l-pill-dot" />Discovery Automático</span>
        </div>
      </div>

      {/* — right card panel — */}
      <div className="l-card-wrap">
        <div className="l-card">
          <h2 className="l-card-title">Bienvenido</h2>
          <p className="l-card-sub">Accede con tu cuenta corporativa</p>

          <button type="button" className="l-sso-btn" onClick={handleIdPLogin}>
            <span className="l-sso-icon">🔐</span>
            {t('login.ssoButton', 'Sign in with Adder IdP')}
          </button>

          <div className="l-divider">o</div>

          <button type="button" className="l-demo-btn" onClick={handleDemoLogin}>
            🧪 &nbsp;Demo Mode
          </button>

          {/* Página pública: se pasa a quien instala el agente en un servidor
              y todavía no tiene cuenta en el CMDB. */}
          <p className="l-agent-link">
            ¿Vas a instalar el agente?{' '}
            <a href="/instalar-agente">Descarga e instrucciones</a>
          </p>

          <p className="l-footer">
            Plataforma de gestión de configuración · Adder Suite
          </p>
        </div>
      </div>

    </div>
  );
}

export default Login;
